module.exports = __webpack_public_path__ + "af9411843baa449684ac8c6f34d66a31.jpg";